// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"030ef5d9","732":"0590c4ae","977":"dd8c3b34"}[chunkId] + ".chunk.js";
};